// Use event delegation so listeners survive cart section re-renders
document.addEventListener('input', function (e) {
  if (e.target.id !== 'engraving-text') return;
  var charCount = document.getElementById('engraving-char-count');
  if (charCount) {
    charCount.textContent = e.target.value.length;
  }
});

document.addEventListener('click', function (e) {
  var addBtn = e.target.closest('#add-engraving-btn');
  if (!addBtn) return;

  var textarea = document.getElementById('engraving-text');
  var errorEl = document.getElementById('engraving-error');
  if (!textarea) return;

  var text = textarea.value.trim();
  if (errorEl) {
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  if (!text) {
    if (errorEl) {
      errorEl.textContent = 'Please enter your engraving text.';
      errorEl.hidden = false;
    }
    return;
  }

  var variantId = addBtn.getAttribute('data-variant-id');
  if (!variantId) return;

  addBtn.disabled = true;
  addBtn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: parseInt(variantId, 10),
      quantity: 1,
      properties: {
        'Engraving Text': text
      }
    })
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || 'Could not add engraving to cart.');
        });
      }
      return response.json();
    })
    .then(function () {
      window.location.reload();
    })
    .catch(function (err) {
      if (err.name === 'AbortError') return;
      if (errorEl) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      }
      addBtn.disabled = false;
      addBtn.textContent = 'Add to Cart';
    });
});
